import { createSlice } from "@reduxjs/toolkit";

const initialPrivateNotice = {
  definition: "",
  explanation: ""
};

const initialPrivateNoticesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  filterList: [],
  privateNotice: initialPrivateNotice
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const privateNoticeSlice = createSlice({
  name: "privateNotices",
  initialState: initialPrivateNoticesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getFilterList
    filterListFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.filterList = entities;
    },
    //getPrivateNoticeDetail
    privateNoticeFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.privateNotice = entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanListState
    listStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
    },
    //cleanPrivateNoticesState
    privateNoticesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.filterList = [];
      state.totalCount = 0;
      state.privateNotice = initialPrivateNotice;
    }
  }
});